import React, { useEffect } from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { StripeElementsOptions, loadStripe } from '@stripe/stripe-js';
import PaymentCollection from 'src/checkout/components/payment-collection';
import { AvailablePlan, PlanCadence } from 'src/pricing/types';

import PaymentCollectionSkeleton from '../payment-collection-skeleton';
import SmallPrintDetails from '../small-print-details';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY!);

type BillingDetailsComponentOwnProps = {
  chosenPlan: AvailablePlan | null;
  handleSelectCadence: (cadence: PlanCadence) => void;
  selectedCadence: PlanCadence | null;
};

export type BillingDetailsComponentProps = BillingDetailsComponentOwnProps & {
  clientSecret: string | null;
  redirectStatus: 'succeeded' | undefined;
  fetchIntent: (planId: string) => any;
};

export const BillingDetailsComponent: React.FC<
  BillingDetailsComponentProps
> = ({ clientSecret, chosenPlan, fetchIntent, selectedCadence }) => {
  useEffect(() => {
    if (chosenPlan && selectedCadence && !clientSecret) {
      fetchIntent(chosenPlan[selectedCadence].id);
    }
  }, [clientSecret, chosenPlan, selectedCadence]);

  if (!clientSecret) {
    return (
      <>
        <PaymentCollectionSkeleton />
        <SmallPrintDetails />
      </>
    );
  }

  const options = {
    loader: 'never',
    clientSecret,
  } as StripeElementsOptions;

  return (
    <>
      <Elements stripe={stripePromise} options={options} key={clientSecret}>
        <PaymentCollection />
      </Elements>
      <SmallPrintDetails />
      {/* TODO: add ReCAPTCHA */}
    </>
  );
};
